import $api from "../http";
import { IReferralMember } from "../models/ReferralMember";

class ReferralProgramServiceClass {
  async getReferralTokenByUserId(userId: string) {
    return await $api.get<{ token: string }>("/api/referral-token/get-by-user-id/" + userId);
  }

  async getAllEReferralMembersByUserId(userId: string) {
    return await $api.get<{ amount: number; members: IReferralMember[] }>(
      "/api/referral-member/get-by-user-id/" + userId
    );
  }

  async sendReferralInvationOnEmail(model: { userId: string; email: string; lang: string }) {
    return await $api.post<boolean>("/api/referral-token/send-email", model);
  }
}

export const ReferralProgramService = new ReferralProgramServiceClass();
